import { render, staticRenderFns } from "./createFacebookAudiencePopup.vue?vue&type=template&id=fb54a93e&"
import script from "./createFacebookAudiencePopup.vue?vue&type=script&lang=js&"
export * from "./createFacebookAudiencePopup.vue?vue&type=script&lang=js&"
import style0 from "./createFacebookAudiencePopup.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports